import React from 'react'
import moment from 'moment';
import 'moment-timezone';

import { useParams, useLocation } from 'react-router-dom';

import { useGetStudentDetails } from '../../../hooks/students';

import StudentDetailsLayout from '../../layouts/Student';

import { useGetChangeLog } from '../../../hooks/change_log';

import { ChangeLogSource } from '../../../interfaces/change_log';


const ChangeLogPage = () => {
    const location = useLocation();

    const { studentId: studentIdParam } = useParams();
    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

    const { data: student } = useGetStudentDetails(studentId);
    const { data: changeLogs, isLoading: isChangeLogLoading } = useGetChangeLog({
        source: ChangeLogSource.STUDENT_DETAILS,
        source_id: studentId,
    });

    const changeLogLoadingView = (
        <div className="display_flex flex_dir_column display_flex_center">
            <br /><br />
            <span className="wt_600 pb_10">Loading</span>
            <i className='immersion__list_loader' />
        </div>
    );

    const changeLogEmptyView = (
        <div className="display_flex flex_dir_column display_flex_center">
            <br /><br />
            <span className="wt_600 pb_10">No record yet.</span>
        </div>
    );

    const changeLogListView = changeLogs?.map((cLog, index) =>
        <div key={index} className="immersion__change_log__card">
            <div className="immersion__change_log__card__left">
                <p className="immersion__change_log__card__title">{cLog.title}</p>
                <p className="immersion__change_log__card__description">{cLog.description}</p>
                {cLog.log.length > 0 &&
                    <ul className="immersion__change_log__card__changes">
                        {cLog.log.map((changeField, idx) => {
                            const field = changeField.name;
                            const oldValue = changeField.old_value;
                            const newValue = changeField.new_value;

                            let fieldView: JSX.Element | null = null;
                            if (oldValue === '' && newValue?.trim()?.length > 0) {
                                fieldView = <span>{field} ({newValue}) is added.</span>;
                            } else if (newValue === '' && oldValue?.trim()?.length > 0) {
                                fieldView = <span>{field} ({oldValue}) is removed.</span>;
                            } else {
                                fieldView = <span>{field} is updated from {oldValue} to {newValue}.</span>;
                            }

                            return (
                                <li key={idx}>
                                    {fieldView}
                                </li>
                            );
                        })}
                    </ul>
                }
            </div>
            <div className="immersion__change_log__card__right">
                <p className="immersion__change_log__card__date">
                    {moment.utc(cLog.created_at).tz('America/New_York').format('MMM-DD-YYYY, H:MM a z')}
                </p>
            </div>
        </div>
    );

    const changeLogView = changeLogs?.length ? changeLogListView : changeLogEmptyView;

    return (
        <StudentDetailsLayout
            goBackRoute={location.state?.goBackRoute ?? null}
            operation='update'
            currentTab="Change-Log"
            title={student?.first_name + ' ' + student?.last_name}
            error={false}
            linkedStatus={{
                isDataAvailable: !!studentId,
                linked: !!student?.date_linked,
                linkedDate: student?.date_linked ?? null,
                unlinkedDate: student?.date_unlinked ?? null,
            }}
            isStudentAdded={!!student}
        >
            <div className='immersion__change_log__page_view'>
                {
                    isChangeLogLoading
                        ? changeLogLoadingView
                        : changeLogView
                }
            </div>
        </StudentDetailsLayout>
    )

}

export default ChangeLogPage;